import { Radio } from 'antd'
import clx from 'classnames'
import styles from './RadioGroup.css'

const {
  Group: RadioGroup
} = Radio

const CommonRadioGroup = props => {
  const { className, ...restProps } = props
  return (
    <RadioGroup
      optionType='button'
      className={clx(
        styles.RadioGroup,
        { [className]: className }
      )}
      {...restProps}
    />
  )
}

export default CommonRadioGroup
